module.exports = __webpack_public_path__ + "img/Token.667e015e.png";